
import { defineStore } from "pinia";
import { ref } from 'vue'

export const useGenericStore = (storeName:string, defaultValue:any=null)=>{
    return defineStore(storeName, ()=>{
        const state = ref(defaultValue);
        const get = ()=>(state.value);
        const set = (newVal)=>(state.value = newVal);
        return {state,get,set} ;
    })();
}